import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { InventoryPartUsed } from '../../api/api-generated';
import {
  useFindAllInventoryPartsQuery,
  useFindAllInventoryPartsUsedQuery,
} from '../../api/api-hooks';
import LptRMAPartAdder from './LptRMAPartAdder';
import LptRMAPartRemover from './LptRMAPartRemover';

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  clickedRma: string | number;
}

export default function LptRmaPartsDialog({
  dialogOpen,
  setDialogOpen,
  clickedRma,
}: Props) {
  const { data: parts } = useFindAllInventoryPartsUsedQuery({});
  const { data: availableParts } = useFindAllInventoryPartsQuery({});
  const [formState, setFormState] = useState<Array<InventoryPartUsed>>([]);
  const [addFormActive, setAddFormActive] = useState<boolean>(false);
  const [removeFormActive, setRemoveFormActive] = useState<boolean>(false);
  // When parts or selected RMA changes, set form state from database
  useEffect(() => {
    if (parts === undefined) return;
    const selectedParts = parts.filter(
      (part) => Number(part.rmaId) === Number(clickedRma)
    );
    setFormState(selectedParts);
  }, [parts, clickedRma]);

  if (parts === undefined || availableParts === undefined) return null;

  const closeDialog = () => {
    setDialogOpen(false);
    // Reset form to database state
    const selectedParts = parts.filter(
      (part) => Number(part.rmaId) === Number(clickedRma)
    );
    setFormState(selectedParts);
    setAddFormActive(false);
    setRemoveFormActive(false);
  };
  return (
    <Dialog fullWidth open={dialogOpen} aria-labelledby='form-dialog-title'>
      <DialogTitle id='form-dialog-title'>RMA Parts Used</DialogTitle>
      <DialogContent>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            {formState.length === 0 && (
              <Typography>No parts associated with this RMA.</Typography>
            )}
            <List>
              {formState.map((part) => {
                return (
                  <>
                    <ListItem key={part.id}>
                      <Typography>
                        {part.partName} ({part.amount} used)
                      </Typography>
                    </ListItem>
                  </>
                );
              })}
            </List>
          </Grid>
          <Grid item>
            <LptRMAPartAdder
              addFormActive={addFormActive}
              setAddFormActive={setAddFormActive}
              clickedRma={clickedRma}
            />
            <LptRMAPartRemover
              removeFormActive={removeFormActive}
              setRemoveFormActive={setRemoveFormActive}
              partsUsed={formState}
            />
          </Grid>
          {!addFormActive && !removeFormActive && (
            <Grid item container spacing={1}>
              <Grid item>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    setAddFormActive(true);
                  }}
                >
                  Add Parts
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    setRemoveFormActive(true);
                  }}
                >
                  Remove Parts
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
